import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Help.css';

const Help = () => {
    const [checkedItems, setCheckedItems] = useState({});

    const steps = [
        "I've verified the tracking code is pasted on my landing page. I pasted it as 'code' and not 'text'",
        "I've verified the tracking code is pasted on my thank you page. I pasted it as 'code' and not 'text'",
        "I've tested going through the funnel after clicking on a Revtrack tracking link & made sure that the correct thank you page is loaded immediately after the conversion",
        "When testing, I have used incognito mode (The script only tracks one conversion per person. Hence, to test the conversion tracking yourself multiple times, you should use an incognito window)",
        "I've added Revtrack links to my videos / the video(s) I tested going through the funnel with",
        "I've verified my landing page and thank you page are under the same domain",
        "If my problem is that some data is missing, I have made sure to add revtrack tracking to ALL places where traffic may be coming from (Youtube channel page link, Instagram, email list etc)",
        "If my problem is that some data is missing, I recognize that Revtrack wont't track 100% of conversions/clicks. However, a significant amount of data is not being tracked properly",
        "The software I am using is not 1) Skool or 2) Podia. We currently cannot support these softwares as they don't allow custom code in the way Revtrack needs it.",
    ];

    const handleCheckboxChange = (index) => {
        setCheckedItems(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const areAllChecked = () => {
        return steps.every((_, index) => checkedItems[index]);
    };

    return (
        <div className="help-container">
            <h2>RevTrack Interactive Troubleshooting</h2>

            <h3>Having issues? Please try all this first before making a support request. 99% of problems are related to not doing one of these steps.</h3>
            <div className="problem-details">
                <div className="checklist">
                    {steps.map((step, index) => (
                        <label key={index} className="checkbox-label">
                            <input
                                type="checkbox"
                                checked={checkedItems[index] || false}
                                onChange={() => handleCheckboxChange(index)}
                            />
                            <span className="step-text">
                                <span className="step-number">{index + 1}.</span>
                                {step}
                            </span>
                        </label>
                    ))}
                </div>

                {areAllChecked() && (
                    <div className="support-message">
                        Please make a post inside the support Discord, or email hi@getrevtrack.com with details about your problem, 
                        and include your landing page, thank you page & channel links. 
                    </div>
                )}
            </div>
        </div>
    );
};

export default Help;
